// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select {
    position: relative;
}

.options {
    position: absolute;
    display: none;
    background-color: var(--surface);
    margin-block-start: 2px;
    z-index: 2;
    width: 150px;
    border-radius: var(--radius-extra-small);
    box-shadow: var(--elevation-2);
}

.options ul {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
}

.options ul li {
    padding: 8px;
    cursor: pointer;
    margin: 2px;
}

.options ul li:hover {
    background-color: var(--surface-variant-transparency);
    color: var(--on-primary-container);
    border-radius: var(--radius-extra-small);
}

.options ul li.selected {
    background-color: var(--primary-container);
    color: var(--on-primary-container);
    border-radius: var(--radius-extra-small);
}

.arrow {
    margin-left: auto;
    transform: rotate(0deg); /* Initial arrow rotation */
    transition: transform 0.6s; /* Add a transition for the arrow */
    margin-top: 2.5px;
}

.arrow-rotate {
    transform: rotate(180deg); /* Rotate the arrow when the options are open */
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/custom-menu-down.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gCAAgC;IAChC,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;AACf;;AAEA;IACI,qDAAqD;IACrD,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,0CAA0C;IAC1C,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,uBAAuB,EAAE,2BAA2B;IACpD,0BAA0B,EAAE,mCAAmC;IAC/D,iBAAiB;AACrB;;AAEA;IACI,yBAAyB,EAAE,+CAA+C;AAC9E","sourcesContent":[".custom-select {\n    position: relative;\n}\n\n.options {\n    position: absolute;\n    display: none;\n    background-color: var(--surface);\n    margin-block-start: 2px;\n    z-index: 2;\n    width: 150px;\n    border-radius: var(--radius-extra-small);\n    box-shadow: var(--elevation-2);\n}\n\n.options ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n}\n\n.options ul li {\n    padding: 8px;\n    cursor: pointer;\n    margin: 2px;\n}\n\n.options ul li:hover {\n    background-color: var(--surface-variant-transparency);\n    color: var(--on-primary-container);\n    border-radius: var(--radius-extra-small);\n}\n\n.options ul li.selected {\n    background-color: var(--primary-container);\n    color: var(--on-primary-container);\n    border-radius: var(--radius-extra-small);\n}\n\n.arrow {\n    margin-left: auto;\n    transform: rotate(0deg); /* Initial arrow rotation */\n    transition: transform 0.6s; /* Add a transition for the arrow */\n    margin-top: 2.5px;\n}\n\n.arrow-rotate {\n    transform: rotate(180deg); /* Rotate the arrow when the options are open */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
